module.exports = __webpack_public_path__ + "img/benefits-slider-3.0d70c1db.png";